import React, { Component } from 'react';

import widgetWrapper from './widgetWrapper';

import './ExpandableTableWidget.scss';


class ExpandableTableWidget extends Component {

  render() {

    const {
      headers = "",
      rows = "",
    } = this.props;

    // console.log(this.props);
    // console.log(headers, rows);


    return (
      <div className='ExpandableTableWidget'>
        <table>
          <tr className='first-row'> {
            headers.map(item => (
              <th>{item}</th>
            ))}
          </tr>
          {rows.map(row => (
            <tr>{row.map(item => (
              <td>{item}</td>
            ))}</tr>
          ))}
        </table>
      </div>
    );
  }
}

export default widgetWrapper(ExpandableTableWidget);
